/**
 * Model page path and deep-link helpers (Game Picks, Picks of the Day → /mlb/...).
 */

/**
 * @param {string | undefined | null} pickType
 * @returns {string}
 */
export function modelPathForPickType(pickType) {
  const t = (pickType || '').toString().trim().toLowerCase();
  if (t === 'total_bases') return '/mlb/total-bases';
  if (t === 'hr') return '/mlb/hr';
  if (t === 'hit') return '/mlb/hit';
  if (t === 'two_hit') return '/mlb/two-hits';
  return '/mlb/total-bases';
}

/**
 * Build `/mlb/...?date=...&player=...&expand=1` for isolated expanded card on model pages.
 *
 * @param {{ pickType?: string | null, playerName?: string | null, date?: string | null }} args
 * @returns {string}
 */
export function buildModelPageDeepLink({ pickType, playerName, date }) {
  const path = modelPathForPickType(pickType);
  const params = new URLSearchParams();
  const d = date != null ? String(date).trim() : '';
  if (d && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
    params.set('date', d);
  }
  const name = playerName != null ? String(playerName).trim() : '';
  if (name) {
    params.set('player', name);
  }
  params.set('expand', '1');
  const q = params.toString();
  return q ? `${path}?${q}` : path;
}

/**
 * Build `/team-picks?teamId=...&date=...&teamName=...` for roster-wide model views.
 *
 * @param {{ teamId?: string | number | null, date?: string | null, teamName?: string | null }} args
 * @returns {string}
 */
export function buildTeamPicksPath({ teamId, date, teamName }) {
  const params = new URLSearchParams();
  if (teamId != null && String(teamId).trim() !== '') {
    params.set('teamId', String(teamId).trim());
  }
  const d = date != null ? String(date).trim() : '';
  if (d && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
    params.set('date', d);
  }
  if (teamName != null && String(teamName).trim() !== '') {
    params.set('teamName', String(teamName).trim());
  }
  const q = params.toString();
  return q ? `/team-picks?${q}` : '/team-picks';
}
